import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@knowledgehound/laika'
import classnames from 'classnames'
import _uniqueId from 'lodash/uniqueId'

import AddToStory from './AddToStory'
import AddToStudy from './AddToStudy'
import * as styles from './AddContentItemModal.module.scss'

class AddContentItemModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    modalIsOpen: PropTypes.bool.isRequired,
    blockStudyAdd: PropTypes.bool,
    content_object: PropTypes.object.isRequired,
    content_type: PropTypes.string.isRequired,
    id: PropTypes.string,
    name: PropTypes.string,
    study: PropTypes.object,
    currentStories: PropTypes.object,
    currentSession: PropTypes.object,
    newStory: PropTypes.object,
    newCard: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onClickViewStory: PropTypes.func,
    onClickViewStudy: PropTypes.func,
    onCreateError: PropTypes.func,
    intl: PropTypes.object,
  }

  static contextTypes = {
    sendNotification: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.state = {
      addToStorySelection: this.storiesEnabled()
    }
  }

  storiesEnabled = () => {
    const {
      currentSession: { data: currentSession },
    } = this.props

    return currentSession && currentSession.stories_enabled
  }

  studyAddAllowed = () => {
    const {
      currentSession: { data: currentSession },
      content_type,
      blockStudyAdd
    } = this.props

    const isManager = Boolean(currentSession && currentSession.manager)
    return (content_type === "linkeddocument" || content_type === "linkedquestion"  || content_type === "linkedanalysis") && isManager && !blockStudyAdd
  }

  successMessage = (msg, params) => {
    this.context.sendNotification(
      _uniqueId('_addToStoryModal'),
      'success',
      msg,
      params
    )
  }

  showAddToStory = (choice) => {
    this.setState({
      addToStorySelection: choice
    })
  }

  renderOptions () {
    const { addToStorySelection } = this.state

    return (
      <ul className={styles.insightTarget}>
        <li className={classnames(styles.option, { [styles.active]: addToStorySelection })}
          onClick={evt => this.showAddToStory(true)}>
          Add To Story
        </li>
        <li className={classnames(styles.option, { [styles.active]: !addToStorySelection })}
          onClick={evt => this.showAddToStory(false)}>
          Add To Study Summary
        </li>
      </ul>
    )
  }

  render () {
    const {
      modalIsOpen,
      onClose,
      currentSession: { data: session },
      dispatch,
      content_object,
      content_type,
      study,
    } = this.props

    const { addToStorySelection } = this.state

    const studiesEnabled = this.studyAddAllowed()
    const storiesEnabled = this.storiesEnabled()

    const author = session && session.email
    const displayAddToStory = studiesEnabled ? addToStorySelection : storiesEnabled
    let titleText = "Save Insight"
    if (storiesEnabled && !studiesEnabled) {
      // Can add to story but not study (non manager/admin, wrong content item)
      titleText = "Add to Story"
    } else if (studiesEnabled && !storiesEnabled) {
      // Can add to study but not story (A2 spreadsheet)
      titleText = "Add to Study Dashboard"
    }

    return (
      <Modal
        isOpen={modalIsOpen}
        onClose={onClose}
        title={titleText}
        variant="dialog"
      >
        {studiesEnabled && storiesEnabled && this.renderOptions()}
        {displayAddToStory ? (
          <AddToStory
            content_object={content_object}
            content_type={content_type}
            currentStories={this.props.currentStories}
            author={author}
            newCard={this.props.newCard}
            newStory={this.props.newStory}
            onCreateError={this.props.onCreateError}
            onClickViewStory={(this.props.onClickViewStory) || null}
            study={study}
            name={this.props.name}
            id={this.props.id}
            handleClose={onClose}
            successMessage={this.successMessage}
          />
        ) : (
          <AddToStudy
            dispatch={dispatch}
            content_object={content_object}
            content_type={content_type}
            intl={this.props.intl}
            onCreateError={this.props.onCreateError}
            study={study}
            handleClose={onClose}
            successMessage={this.successMessage}
            onClickViewStudy={this.props.onClickViewStudy || null}
          />
        )}
      </Modal>
    )

  }
}

export default AddContentItemModal
